export default __webpack_public_path__ + "static/media/logo-512.53035a61.png";